import { Avatar } from 'ui';
import React, { useEffect, useRef } from 'react';

import type { StudentQuadrantData } from '../types';

import './_student-cluster-tooltip.scss';

type StudentClusterTooltipProps = {
  onClose: () => void;
  onStudentClick?: (student: StudentQuadrantData) => void;
  position: { x: number; y: number };
  students: StudentQuadrantData[];
};

function StudentClusterTooltip({ onClose, onStudentClick, position, students }: StudentClusterTooltipProps): JSX.Element {
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent): void {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
        onClose();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="student-cluster-tooltip" ref={tooltipRef} style={{ left: position.x, top: position.y - 12 }}>
      <div className="student-cluster-tooltip__list">
        {students.map((student) => {
          function handleRowClick() {
            onStudentClick!(student);
            onClose();
          }

          return onStudentClick ? (
            <button
              className="student-cluster-tooltip__row student-cluster-tooltip__row--clickable"
              key={student.userId}
              onClick={handleRowClick}
              type="button"
            >
              <Avatar image={student.avatar || undefined} size="sm" />
              <span className="student-cluster-tooltip__name">
                {student.name} {student.lastName}
              </span>
            </button>
          ) : (
            <div className="student-cluster-tooltip__row" key={student.userId}>
              <Avatar image={student.avatar || undefined} size="sm" />
              <span className="student-cluster-tooltip__name">
                {student.name} {student.lastName}
              </span>
            </div>
          );
        })}
      </div>
      <div className="student-cluster-tooltip__arrow" />
    </div>
  );
}

export default StudentClusterTooltip;
